import * as Yup from 'yup';
import { useFormik } from 'formik';

const CreateUpdateVideoValidationSchema = () =>
  Yup.object().shape({
    title: Yup.string().trim().required('Title is required'),
    description: Yup.string().required('Description is required'),
    thumbnail_url: Yup.string().url('Enter a valid URL')
  });

export default function useVideoFormik(videoData = {}, onSubmit) {
  const formik = useFormik({
    initialValues: {
      title: videoData?.title ?? '',
      description: videoData?.description ?? '',
      thumbnail_url: videoData?.thumbnail_url ?? '',
      file_key: ''
    },
    enableReinitialize: true,
    validationSchema: CreateUpdateVideoValidationSchema,
    onSubmit
  });

  return formik;
}
